import { useOrders } from '@api/useOrders'
import { Horizontal, NothingMessage, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Col, Drawer, Row, Spin } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'

import { Grid } from './Grid'
import { formatters } from '@utils/intl/dateTimeFormatters'

export function DSUReportDrawer({ showingDSUDrawer, setShowingDSUDrawer, statusUpdateRequest }) {
  const [selectedUpdate, setSelectedUpdate] = useState()
  const { useDSUOverviewQuery } = useOrders()
  const { data: DSUOverviewData, status } = useDSUOverviewQuery(statusUpdateRequest)
  if (!statusUpdateRequest) return

  return (
    <Drawer
      title='Device Updates'
      placement='bottom'
      closable
      destroyOnClose
      onClose={() => {
        setSelectedUpdate(null)
        setShowingDSUDrawer(false)
      }}
      open={showingDSUDrawer}
      key='bottom'
      height='94vh'
    >
      <Vertical>
        {selectedUpdate && (
          <Vertical flex='0' height={60} style={{ minHeight: 60 }}>
            <DSUHeader selectedUpdate={selectedUpdate} />
          </Vertical>
        )}

        <Horizontal flex='1'>
          <Vertical flex='2' span={18}>
            <Grid DSUOverviewData={DSUOverviewData} status={status} setSelectedUpdate={setSelectedUpdate} />
          </Vertical>
          <Vertical className='px-3 pt-0' flex='1'>
            <StatusUpdatePayload selectedUpdate={selectedUpdate} />
          </Vertical>
        </Horizontal>
      </Vertical>
    </Drawer>
  )
}

function DSUHeader({ selectedUpdate }) {
  return (
    <Row align='middle' style={{ backgroundColor: 'var(--theme-color-2-dim)', minHeight: '46px', marginBottom: '6px' }}>
      <Col span={2} className='ml-3'>
        <Texto appearance='secondary' weight='bold'>
          Selected Driver:
        </Texto>
      </Col>
      <Col span={16}>
        <Texto category='h6' weight='bold'>
          {selectedUpdate.name}
        </Texto>
      </Col>
      <Col span={2} push={2}>
        <Texto appearance='secondary' weight='bold'>
          Selected Shift:{' '}
        </Texto>
      </Col>
      <Col span={3} push={2}>
        <Texto category='h6' weight='bold'>
          {formatters.DATE(moment(selectedUpdate.date))}
        </Texto>
      </Col>
    </Row>
  )
}

function StatusUpdatePayload({ selectedUpdate }) {
  const { useDSUPayloadQuery } = useOrders()
  const { data: DSUDetails, isFetching } = useDSUPayloadQuery(selectedUpdate?.id)
  if (isFetching) {
    return (
      <>
        <Texto category='h5' className='mt-3 mb-4'>
          Status Update Payload
        </Texto>
        <div className='product-management-container flex items-center justify-center bg-3'>
          <Spin />
        </div>
      </>
    )
  }
  if (!DSUDetails) {
    return (
      <>
        <Texto className='mt-3 mb-4' category='h5'>
          Status Update Payload
        </Texto>
        <div className='product-management-container'>
          <NothingMessage title='No Updates' message='Please check back after driver completes trip updates.' />
        </div>
      </>
    )
  }
  return (
    <>
      <Texto category='h5' className='mt-3 mb-4'>
        Status Update Payload
      </Texto>
      <div className='product-management-container bg-3'>
        <pre>{JSON.stringify(DSUDetails, undefined, 2)}</pre>
      </div>
    </>
  )
}
